export function isNativeRuntime() {
  if (typeof window === 'undefined') return false;

  const nativeWindow = window as Window & {
    Capacitor?: { isNativePlatform?: () => boolean; getPlatform?: () => string };
    androidBridge?: unknown;
    webkit?: { messageHandlers?: { bridge?: unknown } };
  };

  if (nativeWindow.Capacitor?.isNativePlatform?.()) return true;
  if (nativeWindow.Capacitor?.getPlatform?.() && nativeWindow.Capacitor.getPlatform() !== 'web') return true;
  if (nativeWindow.androidBridge || nativeWindow.webkit?.messageHandlers?.bridge) return true;
  if (window.location.protocol === 'capacitor:') return true;

  return /\bwv\b/i.test(window.navigator.userAgent) && /Android/i.test(window.navigator.userAgent);
}
